import { render, staticRenderFns } from "./ReviewStatItem.vue?vue&type=template&id=13e5e2f2&"
import script from "./ReviewStatItem.vue?vue&type=script&lang=js&"
export * from "./ReviewStatItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports